const textFileMimeToExtensionMap = {
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xls',
  'text/csv': 'csv',
  'text/plain': 'txt'
};
export const getExtensionByMimeType = mimeType => {
  return textFileMimeToExtensionMap[mimeType] ?? null;
};
export const imageMimeTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'];
export const isImage = file => {
  return imageMimeTypes.includes(file.type);
};
//# sourceMappingURL=mimeUtils.js.map